import React, { useState, useEffect, useMemo } from "react";
import {
  ordersCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { date } from "../../../utils/dateTime";
//component
import TabPanel from "../../../components/TabPanel";
import Gap from "../../../components/Gap";
//material ui
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import useStyle from "./style";
import DetailDialog from "./DetailDialog";
import EmptyOrder from "./EmptyOrder";
import { Button, Divider, useMediaQuery, useTheme } from "@material-ui/core";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";

function SudahBayarItem({ order }) {
  const classes = useStyle();
  const history = useHistory();
  const [suborders, setSuborders] = useState([]);
  useEffect(() => {
    async function fetchSuborders() {
      const suborders = await ordersCollection
        .doc(order.id)
        .collection("suborders")
        .where("order_info.owner_id", "==", order.order_info.owner_id)
        .get();

      setSuborders(
        suborders.docs.map((doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        })
      );
    }
    fetchSuborders();
  }, [order.id]);

  const { enqueueSnackbar } = useSnackbar();

  const theme = useTheme();

  const miniScreen = useMediaQuery(theme.breakpoints.down("960"));

  const handleDetail = (e) => {
    setDialog({
      open: true,
      orderId: order.id,
    });
  };

  const [dialog, setDialog] = useState({
    open: false,
    orderId: {},
  });

  const totalBarang = useMemo(() => {
    let total = 0;
    suborders.map((x) => {
      total = total + x.products.length;
    });
    return total;
  });

  return (
    <>
      <Paper elevation={0} className={classes.wrapPaper} onClick={handleDetail}>
        <div className={classes.wrapHeaderTitle}>
          <div>
            <Typography className={classes.liquidSecondList}>
              {date(order.created_at?.toDate?.())}
            </Typography>
          </div>
          <div className={classes.belumBayar}>
            <Brightness1Icon
              style={{ fontSize: "10px", color: "#4caf50", marginRight: "5" }}
            />
            <Typography className={classes.liquidSecondList}>
              Sudah Dibayar
            </Typography>
          </div>
        </div>
        <Divider />
        <div
          className={classes.wrapHeaderTitle}
          style={{ marginBottom: "10px", marginTop: "10px" }}
        >
          <div>
            <CopyToClipboard
              text={order?.kode_order}
              onCopy={() => {
                enqueueSnackbar("Kode Order Berhasil Disalin", {
                  variant: "success",
                });
              }}
            >
              <Typography variant="caption" display="block">
                <b>{order?.kode_order}</b>
              </Typography>
            </CopyToClipboard>{" "}
          </div>
          <div className={classes.belumBayar}>
            <FileCopyOutlinedIcon
              color="primary"
              style={{ width: "15", height: "15" }}
            />
          </div>
        </div>
        {/* <Grid container direction="row" justify="center" alignItems="center">
          <div className={classes.orderColTopLeft}>
            <div className={classes.innerRow}>
              <div className={classes.timelineStatus}>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      order.status === "pending" ||
                      order.status === "paid" ||
                      order.status === "on-process" ||
                      order.status === "on-delivery" ||
                      order.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <ScheduleIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      order.status === "paid" ||
                      order.status === "on-process" ||
                      order.status === "on-delivery" ||
                      order.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <CheckCircleIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      order.status === "on-process" ||
                      order.status === "on-delivery" ||
                      order.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <AutorenewIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      order.status === "on-delivery" ||
                      order.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <LocalShippingIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      order.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <RoomIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid> */}
        <List>
          {/* <ListItem>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  {totalBarang} Barang
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              {order.total_kredit_wallet ? (
                <div className={classes.totalPembayaran}>
                  <p>Kredit Digunakan</p>
                  <p>{currency(order.total_kredit_wallet)}</p>
                </div>
              ) : (
                <>
                  <Typography className={classes.liquidBold}>
                    Total Pembayaran{" "}
                  </Typography>
                  <Typography className={classes.liquidPrimary}>
                    {currency(order.total_pembayaran)}
                  </Typography>
                  </>
              )}
            </ListItemSecondaryAction>
          </ListItem> */}
          <ListItem style={{ backgroundColor: "#C7D9FF" }}>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  Dikirim ke
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <Typography className={classes.liquidBold}>
                {suborders.length} Alamat Pengirim
              </Typography>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemIcon style={{ minWidth: "40px" }}>
              <CheckCircleOutlineIcon />
            </ListItemIcon>
            <ListItemText
              secondary={
                <Typography
                  style={
                    miniScreen ? { fontSize: "10px" } : { fontSize: "12px" }
                  }
                  className={classes.liquidSecondList}
                >
                  Pembayaran telah diterima, paket akan segera diprosess
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              {/* <IconButton edge="end" size="small" > */}
              <Button
                onClick={() => history.push("/")}
                color="primary"
                variant="contained"
                size="small"
              >
                <Typography
                  style={{ color: "white", fontSize: "10px", padding: "2px" }}
                  className={classes.liquidSecondList}
                >
                  Beli Lagi
                </Typography>
              </Button>
              {/* <NavigateNextIcon /> */}
              {/* </IconButton> */}
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Paper>
      <Gap height={30} />
      <DetailDialog
        open={dialog.open}
        orderId={dialog.orderId}
        handleClose={() => {
          setDialog({
            open: false,
            orderId: {},
          });
        }}
      />
    </>
  );
}

function SudahBayar({ value, modes }) {
  const { orders } = useData();
  const pendingOrders =
    orders
      ?.filter((order) => {
        return (
          (modes === order.order_info?.location &&
            order.status === "paid" &&
            order.status_pengiriman === "pending") ||
          order.status_pengiriman === "ready-for-process" || order.status_pengiriman === "queued"
        );
      })
      .sort((a, b) => {
        const m2 = b.paid_at?.toMillis?.() ?? 0;
        const m1 = a.paid_at?.toMillis?.() ?? 0;

        return m2 - m1;
      }) ?? [];

  return (
    <TabPanel style={{ backgroundColor: "#EFF1FE" }} value={value} index="paid">
      <div>
        {pendingOrders && pendingOrders.length > 0 ? (
          pendingOrders.map((item) => {
            return <SudahBayarItem key={item?.id} order={item} />;
          })
        ) : (
          <EmptyOrder />
        )}
      </div>
    </TabPanel>
  );
}

export default SudahBayar;
